import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsFlashDrive1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.67 0v7.62H9.15v1.53H7.62v19.81h1.53V10.67h13.71v18.29h1.52V9.15h-1.52V7.62h-1.52V0Zm9.14 7.62h-7.62V1.53h7.62Zm1.53 21.34h1.52v1.52h-1.52Zm-10.67 1.52h10.67V32H10.67Z\"/><path fill=\"currentColor\" d=\"M18.29 24.38h1.52v1.53h-1.52Zm0-3.04h1.52v1.52h-1.52ZM16.76 3.05h1.53V6.1h-1.53Zm-3.04 22.86h4.57v1.52h-4.57Zm0-22.86h1.52V6.1h-1.52Zm-1.53 21.33h1.53v1.53h-1.53Zm0-3.04h1.53v1.52h-1.53Zm-3.04 7.62h1.52v1.52H9.15Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsFlashDrive1
